import { AutomationActionTypeEnum } from '../../../shared/models';
import { subEnum } from '../../../shared/models/enum/sub-enum.helper';

export const AutomationRiskCodeActionEnum = subEnum(AutomationActionTypeEnum, [
  'exit',
  'log',
  'lookup',
  'set_risk',
]);
